import {
  CaregiverRankBedsideBuddyIcon,
  CaregiverRankComfortCrusaderIcon,
  CaregiverRankCompassionChampionIcon,
  CaregiverRankCozyCompanionIcon,
  CaregiverRankDoseOfDelightDynamoIcon,
  CaregiverRankGrinGuruIcon,
  CaregiverRankHappyHealerIcon,
  CaregiverRankHarmonyHuntsmanIcon,
  CaregiverRankHomeHeroIcon,
  CaregiverRankHugHarbingerIcon,
  CaregiverRankJoyJuggernautIcon,
  CaregiverRankLaughterLuminaryIcon,
  CaregiverRankPajamaProfessionalIcon,
  CaregiverRankPatientPalIcon,
  CaregiverRankPositivityPioneerIcon,
  CaregiverRankRookieCaregiverIcon,
  CaregiverRankSereneSamaritanIcon,
  CaregiverRankSerenitySorcererIcon,
  CaregiverRankShiftSuperstarIcon,
  CaregiverRankSmilesmithIcon,
  CaregiverRankTranquilityTrailblazerIcon,
  CaregiverRankVisitVirtuosoIcon,
  CaregiverRankWellnessWarriorIcon,
  CaregiverRankWellnessWizardIcon,
  CaregiverRankZenZealotIcon,
} from "../CareMomentsIntro/caregiver-rank-icons";

export const careMomentsIcons = {
  "bedside-buddy": CaregiverRankBedsideBuddyIcon,
  "comfort-crusader": CaregiverRankComfortCrusaderIcon,
  "compassion-champion": CaregiverRankCompassionChampionIcon,
  "cozy-companion": CaregiverRankCozyCompanionIcon,
  "dose-of-delight-dynamo": CaregiverRankDoseOfDelightDynamoIcon,
  "grin-guru": CaregiverRankGrinGuruIcon,
  "happy-healer": CaregiverRankHappyHealerIcon,
  "harmony-huntsman": CaregiverRankHarmonyHuntsmanIcon,
  "home-hero": CaregiverRankHomeHeroIcon,
  "hug-harbinger": CaregiverRankHugHarbingerIcon,
  "joy-juggernaut": CaregiverRankJoyJuggernautIcon,
  "laughter-luminary": CaregiverRankLaughterLuminaryIcon,
  "pajama-professional": CaregiverRankPajamaProfessionalIcon,
  "patient-pal": CaregiverRankPatientPalIcon,
  "positivity-pioneer": CaregiverRankPositivityPioneerIcon,
  "rookie-caregiver": CaregiverRankRookieCaregiverIcon,
  "serene-samaritan": CaregiverRankSereneSamaritanIcon,
  "serenity-sorcerer": CaregiverRankSerenitySorcererIcon,
  "shift-superstar": CaregiverRankShiftSuperstarIcon,
  smilesmith: CaregiverRankSmilesmithIcon,
  "tranquility-trailblazer": CaregiverRankTranquilityTrailblazerIcon,
  "visit-virtuoso": CaregiverRankVisitVirtuosoIcon,
  "wellness-warrior": CaregiverRankWellnessWarriorIcon,
  "wellness-wizard": CaregiverRankWellnessWizardIcon,
  "zen-zealot": CaregiverRankZenZealotIcon,
};
